<template>
  <ion-row>
    <ion-col size-md="12" size-lg="12">
      <section>
        <h3 class="h3 text-color-body">{{ t('signUp.passwordTitle') }}</h3>
        <p class="text-color-body text-align-left font-xs mt-xs">
          {{ t('signUp.passwordDescription') }}
        </p>
        <ul class="font-xs">
          <li>{{ t('signUp.passwordDescriptionLeast.minCharacters') }}</li>
          <li>{{ t('signUp.passwordDescriptionLeast.uppercase') }}</li>
          <li>{{ t('signUp.passwordDescriptionLeast.lowercase') }}</li>
          <li>{{ t('signUp.passwordDescriptionLeast.number') }}</li>
          <li>{{ t('signUp.passwordDescriptionLeast.special') }}</li>
        </ul>
        <div class="mt-lg">
          <CustomInput
            form-name="sign-up"
            type="password"
            :value="signUpForm.password"
            v-model="signUpForm.password"
            input-type="password"
            :label="t('login.labels.password')"
            name="password"
            class-name="custom-field"
            :placeholder="t('signUp.placeholders.password')"
            :icon="lockClosedOutline"
            :clear-field="false"
          />
        </div>
      </section>
    </ion-col>
  </ion-row>
</template>
<script setup lang="ts">
  import { lockClosedOutline } from 'ionicons/icons';
  import { IonCol, IonRow } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { useSignUp } from '@/composables/useSignUp';
  import CustomInput from '@/components/shared/form/CustomInput.vue';

  const { t } = useI18n();
  const { signUpForm } = useSignUp();
</script>
<style scoped lang="scss"></style>
